/**
 * Duh Baddest — Theme JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {

  // ===== Mobile Menu Toggle =====
  const menuToggle = document.getElementById('menu-toggle');
  const navLinks = document.getElementById('nav-links');

  if (menuToggle && navLinks) {
    menuToggle.addEventListener('click', function() {
      navLinks.classList.toggle('active');
      // Animate hamburger
      menuToggle.classList.toggle('active');
    });
  }

  // ===== Quantity Buttons =====
  document.querySelectorAll('.qty-minus, .qty-plus').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const wrapper = this.closest('.quantity-wrapper');
      const input = wrapper.querySelector('input[type="number"]');
      let val = parseInt(input.value) || 1;

      if (this.classList.contains('qty-minus')) {
        val = Math.max(1, val - 1);
      } else {
        val = Math.min(99, val + 1);
      }

      input.value = val;
      input.dispatchEvent(new Event('change'));
    });
  });

  // ===== Variant Selector (update hidden ID) =====
  const variantSelects = document.querySelectorAll('.variant-selector select');
  if (variantSelects.length > 0) {
    variantSelects.forEach(function(select) {
      select.addEventListener('change', function() {
        updateVariant();
      });
    });
  }

  function updateVariant() {
    // Gather selected options
    const selects = document.querySelectorAll('.variant-selector select');
    const selectedOptions = [];
    selects.forEach(function(s) {
      selectedOptions.push(s.value);
    });

    // Find matching variant from product JSON
    if (window.productVariants) {
      const match = window.productVariants.find(function(variant) {
        return variant.options.every(function(opt, i) {
          return opt === selectedOptions[i];
        });
      });

      if (match) {
        const idInput = document.querySelector('input[name="id"]');
        if (idInput) idInput.value = match.id;

        // Update price display
        const priceEl = document.querySelector('.product-price');
        if (priceEl && match.price) {
          priceEl.textContent = '$' + (match.price / 100).toFixed(2);
        }

        // Update button state
        const btn = document.querySelector('.product-page .btn-primary');
        if (btn) {
          if (match.available) {
            btn.disabled = false;
            btn.textContent = 'Add to Cart';
          } else {
            btn.disabled = true;
            btn.textContent = 'Sold Out';
          }
        }
      }
    }
  }

  // ===== Smooth Scroll for Anchor Links =====
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Close mobile menu if open
        if (navLinks) navLinks.classList.remove('active');
      }
    });
  });

  // ===== Header Background on Scroll =====
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 50) {
        header.style.background = 'rgba(140, 0, 70, 0.95)';
      } else {
        header.style.background = 'rgba(180, 0, 90, 0.85)';
      }
    });
  }

});
